export default {
  transactions: [],
  pendingTransactions: [],
  companyTransactions: []
};
